/**
 * 日志与文本 API（辅助工具 → 日志与文本）
 * 含：正则生成与解释（AI + 本地试跑防幻觉）、SQL 与 EXPLAIN 解读（本地格式化 + AI）、
 * 日志智能分析（AI）、定位器生成器（本地解析 + 可选 AI 推荐）
 * AI 能力复用「AI 配置」中已启用的模型
 */
import { post } from '@/utils/request'
import { message } from 'antd'
import type {
  LogAnalyzeAIResult, LocatorResult, RegexAIResult, RegexTestResult,
  SqlExplainAIResult, SqlFormatResult,
} from '@/types'

/** 复制文本到剪贴板 */
export const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)
    message.success('已复制')
  } catch {
    message.error('复制失败')
  }
}

/** 正则 AI：生成（自然语言 → 正则）/ 解释（正则 → 含义） */
export const regexAI = (data: { action: 'generate' | 'explain'; content: string }) =>
  post<RegexAIResult>('/log-text/regex/ai', data)

/** 正则本地试跑（匹配明细 + 高亮分段） */
export const regexTest = (data: {
  pattern: string
  flags?: string[]
  text: string
  mode?: 'findall' | 'search' | 'match' | 'fullmatch'
}) => post<RegexTestResult>('/log-text/regex/test', data)

/** SQL 本地轻量格式化 */
export const sqlFormat = (data: { sql: string; uppercase?: boolean }) =>
  post<SqlFormatResult>('/log-text/sql/format', data)

/** SQL 与 EXPLAIN 执行计划 AI 解读 */
export const sqlExplainAI = (data: { sql: string; plan?: string; dialect?: string }) =>
  post<SqlExplainAIResult>('/log-text/sql/explain', data)

/** 日志智能分析（AI 提取错误、聚类、根因假设） */
export const logAnalyzeAI = (data: { content: string; focus?: string }) =>
  post<LogAnalyzeAIResult>('/log-text/log/analyze', data)

/** 定位器生成（本地候选 XPath/CSS，可选 AI 推荐） */
export const locatorGenerate = (data: { html: string; target_hint?: string; use_ai?: boolean }) =>
  post<LocatorResult>('/log-text/locator', data)
